import { __decorate } from "tslib";
import { AutoEncoder, EnumDecoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { v4 as uuidv4 } from "uuid";
import { Image } from './files/Image';
import { Language } from './Language';
export class WholesalerPrivateSettings extends AutoEncoder {
    constructor() {
        super(...arguments);
        /**
         * E-mail to receive orders on
         */
        this.email = "";
    }
}
__decorate([
    field({ decoder: StringDecoder, version: 6 })
], WholesalerPrivateSettings.prototype, "email", void 0);
export class WholesalerColors extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.primary = "#396C33";
        this.dark = "#340808";
    }
}
__decorate([
    field({ decoder: StringDecoder })
], WholesalerColors.prototype, "primary", void 0);
__decorate([
    field({ decoder: StringDecoder })
], WholesalerColors.prototype, "dark", void 0);
export class WholesalerSettings extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.name = "";
        this.language = Language.nl;
        this.colors = WholesalerColors.create({});
        this.logo = null;
    }
}
__decorate([
    field({ decoder: StringDecoder })
], WholesalerSettings.prototype, "name", void 0);
__decorate([
    field({ decoder: new EnumDecoder(Language), version: 12 })
], WholesalerSettings.prototype, "language", void 0);
__decorate([
    field({ decoder: WholesalerColors })
], WholesalerSettings.prototype, "colors", void 0);
__decorate([
    field({ decoder: Image, nullable: true, version: 5 })
], WholesalerSettings.prototype, "logo", void 0);
/**
 * Wholesaler data that is visible for the customer
 */
export class Wholesaler extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.settings = WholesalerSettings.create({});
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], Wholesaler.prototype, "id", void 0);
__decorate([
    field({ decoder: WholesalerSettings })
], Wholesaler.prototype, "settings", void 0);
/**
 * Wholesaler data that is visible for the business
 */
export class WholesalerPrivate extends Wholesaler {
    constructor() {
        super(...arguments);
        this.privateSettings = WholesalerPrivateSettings.create({});
    }
}
__decorate([
    field({ decoder: WholesalerPrivateSettings })
], WholesalerPrivate.prototype, "privateSettings", void 0);
//# sourceMappingURL=Wholesaler.js.map